<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <div class="active section">
                Relatório de Listagem de Contratos por Cidade
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div ref="modal" class="ui large modal" style="top: 40px">
        <iframe
          ref="viewer"
          width="100%"
          style="height: calc(100vh - 100px)"
        ></iframe>
      </div>
      <form
        :class="['ui small', { error: anyError }, 'form']"
        v-autocomplete-off
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div class="four wide field">
                <label for="cotracts-by-city-report-state"> Situação </label>
                <select
                  id="cotracts-by-city-report-state"
                  class="ui dropdown"
                  v-model="form.state"
                >
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.value"
                  >
                    {{ state.description }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label for="cotracts-by-city-report-city">Cidade</label>
                <CityInput
                  @selected="cityData => (form.city_ibge_code = cityData.value)"
                  ref="city"
                ></CityInput>
              </div>
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="run"
                  type="button"
                  name="run"
                  class="ui submit blue button"
                >
                  <i class="play icon"></i>Gerar Relatório
                </button>
              </div>
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import CityInput from '@/components/city_input';
import ContractEnum from '@/enumerations/contract_enum';
import { mapGetters } from 'vuex';

export default {
  components: { Breadcrumb, PageLayout, CityInput },

  data() {
    return {
      loading: false,
      loaded: false,
      errors: {},
      form: {
        state: null,
        city_ibge_code: null
      },
      states: ContractEnum.states
    };
  },

  computed: {
    anyError() {
      return !_.isEmpty(this.errors);
    },

    ...mapGetters({
      paymentMethods: 'settings/paymentMethods'
    })
  },

  methods: {
    run() {
      this.loading = true;
      let data = {
        report: 'contracts_by_city'
      };

      if (!_.isEmpty(this.form.state)) {
        data.STATUS = this.form.state;
        data.STATUS_DESCRIPTION = this.states.find(
          state => state.value === this.form.state
        )?.description;
      }

      if (this.form.city_ibge_code != null) {
        data.IBGE_CODE = this.form.city_ibge_code;

        const cityDescription = this.$refs.city.$el.children[3].textContent;
        data.CITY_DESCRIPTION = `'${cityDescription}'`;
      }

      Api.report(data)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          $(this.$refs.viewer).attr('src', window.URL.createObjectURL(blob));
          $(this.$refs.modal).modal('show');
        })
        .catch(error => {
          this.showError = true;
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
